<template>
  <b-modal ref="limit-card-modal" @ok="limitCardModalOk">
    <template v-slot:modal-header="{}">
      <div>{{ $store.state.localization.data.mainPage.limits.pageLabel }}</div>
    </template>
    <div style="font-size: 13px">
      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.limits.tableColumns.driver"
        label-for="input-horizontal"
      >
        <b-form-select
          v-model="driverId"
          :options="driverOptions"
          style="font-size: 13px"
        ></b-form-select>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.limits.tableColumns.fuelTypeCode"
        label-for="input-horizontal"
      >
        <b-form-select
          v-model="fuelTypeCode"
          :options="fuelTypeCodeOptions"
          style="font-size: 13px"
        ></b-form-select>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.limits.tableColumns.limitType"
        label-for="input-horizontal"
      >
        <b-form-select
          v-model="limitType"
          :options="limitTypeOptions"
          style="font-size: 13px"
        ></b-form-select>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.limits.tableColumns.limitValue"
        label-for="input-horizontal"
      >
        <b-form-input
          type="number"
          min="1"
          max="100000"
          v-model="limitValue"
          :state="isLimitValueValid"
          style="font-size: 13px"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.limits.tableColumns.cycle"
        label-for="input-horizontal"
      >
        <b-form-select
          v-model="limitCycle"
          :options="cycleOptions"
          style="font-size: 13px"
        ></b-form-select>
      </b-form-group>
      
      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        locale="ua"
        :label="$store.state.localization.data.mainPage.limits.tableColumns.beginTime"
        label-for="input-horizontal"
      >
        <b-form-datepicker
          v-model="beginTime"
          :state="isBeginTimeValid"
          value-as-date="true"
          style="font-size: 13px"
          :locale="calendarLocale"
        ></b-form-datepicker>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        locale="ua"
        :label="$store.state.localization.data.mainPage.limits.tableColumns.endTime"
        label-for="input-horizontal"
      >
        <b-form-datepicker
          v-model="endTime"
          :state="isEndTimeValid"
          value-as-date="true"
          style="font-size: 13px"
          :locale="calendarLocale"
        ></b-form-datepicker>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.limits.tableColumns.limitStatus"
        label-for="input-horizontal"
      >
        <b-form-select
          v-model="limitStatus"
          :options="statusOptions"
          style="font-size: 13px"
        ></b-form-select>
      </b-form-group>
    </div>
    <template v-slot:modal-footer="{ ok, cancel }">
      <b-button variant="success" style="font-size: 12px" @click="ok()">{{
        $store.state.localization.data.common.table.ok
      }}</b-button>
      <b-button variant="light" style="font-size: 12px" @click="cancel()">{{
        $store.state.localization.data.common.table.cancel
      }}</b-button>
    </template>
  </b-modal>
</template>

<script>
import { limitService, utilsService } from "../../../services";

export default {
  name: "UpdateLimitPage",
  components: {},
  props: {
    limit: Object,
    drivers: Array,
  },
  data() {
    return {
      driverId: null,
      fuelTypeCode: null,
      limitType: null,
      limitCycle: null,
      limitStatus: null,
      limitValue: null,
      beginTime: null,
      endTime: null,
      isLimitValueValid: null,
      isBeginTimeValid: null,
      isEndTimeValid: null
    };
  },
  computed: {
    cycleOptions() {
      const cycleOptions = [];

      for (
        let i = 0;
        i <
        this.$store.state.localization.data.mainPage.limits.cycleOptions.length;
        i++
      ) {
        cycleOptions.push({
          value:
            this.$store.state.localization.data.mainPage.limits.cycleOptions[i]
              .key,
          text: this.$store.state.localization.data.mainPage.limits
            .cycleOptions[i].value,
        });
      }
      return cycleOptions;
    },
    driverOptions() {
      const driversOptions = [];

      for (let i = 0; i < this.drivers.length; i++) {
        driversOptions.push({
          value: this.drivers[i].id,
          text: this.drivers[i].lastName + " " + this.drivers[i].firstName,
        });
      }
      return driversOptions;
    },
    fuelTypeCodeOptions() {
      const fuelTypeCodeOptions = [];

      for (
        let i = 0;
        i <
        this.$store.state.localization.data.common.fuelTypeCodeOptions.length;
        i++
      ) {
        fuelTypeCodeOptions.push({
          value:
            this.$store.state.localization.data.common.fuelTypeCodeOptions[i]
              .key,
          text: this.$store.state.localization.data.common.fuelTypeCodeOptions[
            i
          ].value,
        });
      }
      return fuelTypeCodeOptions;
    },
    limitTypeOptions() {
      const limitTypeOptions = [];

      for (
        let i = 0;
        i <
        this.$store.state.localization.data.mainPage.limits.limitTypeOptions
          .length;
        i++
      ) {
        limitTypeOptions.push({
          value:
            this.$store.state.localization.data.mainPage.limits
              .limitTypeOptions[i].key,
          text: this.$store.state.localization.data.mainPage.limits
            .limitTypeOptions[i].value,
        });
      }
      return limitTypeOptions;
    },
    statusOptions() {
      const statusOptions = [];

      for (
        let i = 0;
        i <
        this.$store.state.localization.data.mainPage.limits.statusOptions
          .length;
        i++
      ) {
        statusOptions.push({
          value:
            this.$store.state.localization.data.mainPage.limits
              .statusOptions[i].key,
          text: this.$store.state.localization.data.mainPage.limits
            .statusOptions[i].value,
        });
      }
      return statusOptions;
    },
    calendarLocale() {
      return utilsService.getCalendarLocale(this.$store.state.localization.locale);
    }
  },
  methods: {
    async open() {
      this.isDriverIdValid = null;
      this.isLimitValueValid = null;
      this.isBeginTimeValid = null;
      this.isEndTimeValid = null;
      this.isLimitCycleValid = null;

      this.driverId = this.limit.driverId;
      this.fuelTypeCode = this.limit.fuelTypeCode;
      this.limitType = this.limit.limitType;
      this.limitValue = this.limit.limitValue;
      this.limitCycle = this.limit.limitCycle;
      this.limitStatus = this.limit.limitStatus;
      this.beginTime = utilsService.convertUnixTimeToDate(this.limit.beginTime);
      this.endTime = utilsService.convertUnixTimeToDate(this.limit.endTime);

      this.$refs["limit-card-modal"].show();
    },
    async limitCardModalOk(event) {
      const MIN_LIMIT_VALUE = 1;
      const MAX_LIMIT_VALUE = 10000;

      this.isLimitValueValid = null;
      this.isBeginTimeValid = null;
      this.isEndTimeValid = null;

      if (!this.limitValue) {
        this.isLimitValueValid = false;
        event.preventDefault();
        return;
      } else {
        if (this.limitValue > MAX_LIMIT_VALUE || this.limitValue < MIN_LIMIT_VALUE) {
          this.isLimitValueValid = false;
          event.preventDefault();
          return;
        }
      }

      if (!this.beginTime) {
        this.isBeginTimeValid = false;
        event.preventDefault();
        return;
      }

      if (!this.endTime) {
        this.isEndTimeValid = false;
        event.preventDefault();
        return;
      }

      if (this.beginTime > this.endTime) {
        this.isBeginTimeValid = false;
        event.preventDefault();
        return;
      } else {
        this.isBeginTimeValid = null;
      }

      const limitCard = {
        id: parseInt(this.limit.id),
        driverId: this.driverId,
        fuelTypeCode: this.fuelTypeCode,
        limitType: parseInt(this.limitType),
        limitValue: parseFloat(this.limitValue),
        beginTime: this.beginTime.getTime() / 1000,
        endTime: this.endTime.getTime() / 1000,
        limitCycle: parseInt(this.limitCycle),
        limitStatus: parseInt(this.limitStatus)
      };

      const updateLimitResponse = await limitService.updateLimit(limitCard);

      if (
        updateLimitResponse.isSuccess &&
        updateLimitResponse.data &&
        updateLimitResponse.data.countUpdatedRows == 1
      ) {
        this.$emit("limitUpdatedSuccessEvent", limitCard);
      } else {
        this.$emit("limitUpdatedFailEvent");
      }
    },
  },
};
</script>
